import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Select,
  Spinner,
  Stack,
  Tag,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useState } from 'react'
import { FiChevronDown } from 'react-icons/fi'
import { normalizeString } from '../../../utils/normalizeString'
import { forwardRef } from 'react'
import { api, baseURL } from '../../../services/api'
import { useQuery } from 'react-query'
import { useDebounce } from '../../../hooks/useDebounce'
import { ListProduct } from './ListProduct'
import { AiFillCloseCircle } from 'react-icons/ai'

async function getProductByCategory(category) {
  try {
    const response = await api.post(
      'https://api.innovationbrindes.com.br/api/site/v2/produto/listar-por-subcategoria/',
      {
        codigo_grupo_produto: category,
        codigo_cor: null,
        quantidade: null,
        valor_inicial: null,
        valor_final: null,
        prazo_entrega: null,
      }
    )

    return response.data.map((product) => {
      return {
        ...product,
        url_seo: product.url_seo.toLowerCase() || '',
        nome: product.nome_produto.toLowerCase() || '',
        codigo_produto: product.codprod,
      }
    })
  } catch (err) {
    console.log('error', err)
    return []
  }
}

async function searchProduct(slug) {
  try {
    const uniqueProductResponse = await api.get(
      `/site/v2/busca/busca-produto-site/${slug}`
    )

    if (uniqueProductResponse.data.length > 0) {
      return uniqueProductResponse.data.map((product) => {
        return {
          ...product,
          nome: product.nome.toLowerCase() || '',
        }
      })
    }
  } catch (error) {
    console.log('error', error)
    return []
  }
}

export const SelectProduct = forwardRef(
  ({ onSelectProduct, labelInput }, ref) => {
    const { isOpen, onToggle, onClose } = useDisclosure()
    const [search, setSearch] = useState('')
    const debouncedSearch = useDebounce(search, 500)

    const [selectOption, setSelectOption] = useState('produto')
    const [categorySelected, setCategorySelected] = useState(null)

    const { data: products, isLoading } = useQuery({
      queryKey: ['searchProduct', debouncedSearch],
      queryFn: () => searchProduct(debouncedSearch),
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 24,
    })

    const { data: productsByCategory, isLoading: productsByCategoryLoading } =
      useQuery({
        queryKey: ['getProductByCategory', categorySelected],
        queryFn: () => getProductByCategory(categorySelected?.codigo_grupo),
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60 * 24,
      })

    console.log('productsByCategory', productsByCategory)

    const { data: category, isLoading: categoryLoading } = useQuery(
      'category',
      async () => {
        const [category, colors] = await Promise.all([
          baseURL.get('/detalhes-produto/listar-categorias'),
        ])

        return {
          category: category.data,
        }
      },
      {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60 * 24, // 24 hours
      }
    )

    console.log('data', products)

    function handleSelectProduct(index) {
      onSelectProduct(index)
      onClose()
    }

    const productsSearched =
      selectOption === 'produto' ? products : productsByCategory

    return (
      <Popover
        placement="bottom-end"
        returnFocusOnClose={false}
        isOpen={isOpen}
        onClose={onClose}
      >
        <PopoverTrigger>
          <InputGroup>
            <Button
              children="Selecione o Produto"
              width="230px"
              borderColor={'#C5CED6'}
              borderRightRadius="0"
              border="1px solid #378BBF"
            />
            <Button
              borderLeftRadius={0}
              borderRightRadius="md"
              bg="transparent"
              w="100%"
              border="1px solid #378BBF"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              onClick={onToggle}
              borderColor={'#378BBF'}
            >
              <Text fontSize="sm" mr="auto" textTransform="capitalize">
                {labelInput}
              </Text>
              <Icon as={FiChevronDown} />
            </Button>
          </InputGroup>
        </PopoverTrigger>
        <PopoverContent _focus={{ outline: 'none' }} w="758px">
          <PopoverHeader fontWeight="semibold">
            <Select
              value={selectOption}
              onChange={(e) => setSelectOption(e.target.value)}
              border="1px solid #378BBF"
              borderRadius="md"
              w="100%"
              h="40px"
              bg="white"
              color="#378BBF"
              _focus={{ outline: 'none' }}
              mb="2"
            >
              <option value="produto">
                Pesquisar por nome ou código do produto
              </option>
              <option value="categoria">Pesquisar por categoria</option>
            </Select>

            {selectOption === 'produto' && (
              <Input
                type="text"
                placeholder="Digite o nome ou o código do produto"
                border={0}
                outline="none"
                _focus={{ outline: 'none' }}
                onChange={(e) => setSearch(normalizeString(e.target.value))}
              />
            )}

            {selectOption === 'categoria' && categorySelected && (
              <Flex flexDir="column">
                <Text fontSize="14px" mb="2" mt={2}>
                  Categoria selecionada:
                </Text>
                <Tag colorScheme="blue" size="lg" mb="2" w="fit-content">
                  <AiFillCloseCircle
                    cursor="pointer"
                    onClick={() => setCategorySelected(null)}
                    mr="2"
                  />

                  {categorySelected?.descricao_categoria}
                </Tag>
              </Flex>
            )}
          </PopoverHeader>
          <PopoverArrow />
          {/* <PopoverCloseButton /> */}
          <PopoverBody px={0}>
            <Grid
              templateColumns="repeat(2, 1fr)"
              gridGap="2"
              maxH="500px"
              overflowY="auto"
              p="1"
              //estilizar a barra de rolagem
              css={{
                '&::-webkit-scrollbar': {
                  width: '4px',
                },
                '&::-webkit-scrollbar-track': {
                  width: '6px',
                  borderRadius: '3px',
                  background: '#F1F1F1',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#378BBF',
                  borderRadius: '3px',
                },
              }}
            >
              {(isLoading || productsByCategoryLoading) && (
                <Center gridColumn="1 / 3">
                  <Spinner />
                </Center>
              )}
              <Stack spacing={2} px={4}>
                {productsSearched?.map((product) => (
                  <ListProduct
                    key={product.url_seo}
                    product={product}
                    handleSelectProduct={handleSelectProduct}
                  />
                ))}
              </Stack>
            </Grid>

            <Grid
              templateColumns="repeat(2, 1fr)"
              gridGap="2"
              maxH="500px"
              overflowY="auto"
              p="1"
              css={{
                '&::-webkit-scrollbar': { width: '4px' },
                '&::-webkit-scrollbar-track': {
                  width: '6px',
                  borderRadius: '3px',
                  background: '#F1F1F1',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#378BBF',
                  borderRadius: '3px',
                },
              }}
            >
              {selectOption === 'categoria' && !categorySelected && (
                <Stack spacing={2} p={4}>
                  {categoryLoading && <Spinner />}
                  {category?.category?.map((item, index) => (
                    <Box
                      _hover={{ bg: 'gray.100' }}
                      px={1}
                      cursor="pointer"
                      key={item.codigo_grupo}
                      onClick={() => setCategorySelected(item)}
                    >
                      <Text textTransform="capitalize" fontSize="14px">
                        {item.descricao_categoria.toLowerCase()}
                      </Text>
                    </Box>
                  ))}
                </Stack>
              )}
            </Grid>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    )
  }
)
